export enum SummarySubscriptionContextEnum {
    CURRENT = "CURRENT" ,
    OLD = "OLD",
    NEW = "NEW",
    ADD_OPTION = "ADD_OPTION"
}